import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b5ae78d2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "select-product-modal"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定");

import { computed, ref, watch } from 'vue';
import { getPrizeMerchandiseList } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'SelectPrizeProductModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    defaultSelected: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const keyword = ref('');
    const table = ref();
    const tableData = ref([]);
    const selectedList = ref([]);
    watch(() => props.modelValue, val => {
      if (val) {
        var _table$value;

        keyword.value = '';
        selectedList.value = props.defaultSelected.map(item => _objectSpread({}, item));
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: 50
      }, {
        title: '商品编码',
        field: 'prodNo',
        width: 140,
        showOverflow: true
      }, {
        title: '商品名称',
        field: 'prodName',
        minWidth: 180,
        showOverflow: true
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: 160,
        showOverflow: true
      }, {
        title: '分销商名称',
        field: 'branchName',
        minWidth: 180,
        showOverflow: true
      }, {
        title: '生产厂家',
        field: 'manufacturer',
        minWidth: 180,
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            getPrizeMerchandiseList({
              page: page.currentPage,
              rows: page.pageSize,
              prodName: keyword.value || undefined,
              __warn: true
            }).then(data => {
              tableData.value = data.rows || [];
              resolve({
                total: data.total,
                result: data.rows
              });

              if (selectedList.value.length) {
                setTimeout(() => {
                  var _table$value2;

                  const selectedRows = tableData.value.filter(item => selectedList.value.some(v => v.prodNo === item.prodNo));
                  (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.setCheckboxRow(selectedRows, true);
                }, 300);
              }
            });
          })
        }
      }
    });

    function tableSelectHandle({
      row,
      checked
    }) {
      const findIndex = selectedList.value.findIndex(v => v.prodNo === row.prodNo);

      if (checked && findIndex === -1) {
        selectedList.value.push(row);
      } else if (!checked && findIndex > -1) {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle({
      records,
      checked
    }) {
      if (checked) {
        records.forEach(item => {
          if (!selectedList.value.some(v => v.prodNo === item.prodNo)) {
            selectedList.value.push(item);
          }
        });
      } else {
        tableData.value.forEach(item => {
          const findIndex = selectedList.value.findIndex(v => v.prodNo === item.prodNo);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function reset() {
      var _table$value3;

      keyword.value = '';
      (_table$value3 = table.value) === null || _table$value3 === void 0 ? void 0 : _table$value3.commitProxy('reload');
    }

    function submit() {
      emit('success', selectedList.value);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择商品",
        width: "70%",
        top: "5vh",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商品名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: keyword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
              placeholder: "请输入商品名称",
              clearable: "",
              style: {
                "width": "200px"
              },
              onKeydown: _cache[1] || (_cache[1] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: reset
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};